import Fuse from 'fuse.js';
import React, { useCallback, useState } from 'react';
import { useApi, useWorkspace } from '~/contexts';
import MultiSelect from '../MultiSelect';

export default function SalesforceRecordTypeFilter({ placeholder = 'Salesforce Record Type', name, value, onChange }) {
  const api = useApi();
  const { workspace } = useWorkspace();
  const [data, setData] = useState(null);
  const [options, setOptions] = useState([]);

  const handleSearch = useCallback(
    async (q) => {
      let opts = data;
      if (!data) {
        const { data: result } = await api.www.workspaces(workspace.id).opportunities().getSalesforceRecordTypes();
        opts = result;
        setData(opts);
      }
      if (q) {
        opts = new Fuse(opts, { keys: ['name'], threshold: 0.4 }).search(q).map((result) => result.item);
      }
      setOptions(opts);
    },
    [workspace.id, api, data],
  );

  return (
    <MultiSelect.Filter
      icon="filter"
      placeholder={placeholder}
      name={name}
      value={value}
      renderValue={(value) => value.map((v) => v.name).join('; ')}
      options={options}
      renderOptions={(opts) =>
        opts.map((option) => (
          <MultiSelect.Option key={option.id} {...option.props}>
            {option.name}
          </MultiSelect.Option>
        ))
      }
      isLoading={!data}
      onSearch={handleSearch}
      onChange={onChange}
    />
  );
}
